module.exports = __webpack_public_path__ + "img/candidates.258542a1.svg";